module.exports = __webpack_public_path__ + "static/media/blob_big.3c31bcb6.png";